module.exports = {"trip":"旅行","accommodation":"住宿"}